<template>
  <el-form
    :model="supplier"
    ref="supplierForm"
    :rules="rules"
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">Supplier Information</h4>
    <el-form-item label="Name" prop="name">
      <el-input v-model="supplier.name"></el-input>
    </el-form-item>
    <el-row :gutter="15">
      <el-col :sm="12" :xs="24">
        <el-form-item label="Title" prop="contact_title">
          <el-input v-model="supplier.contact_title"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12" :xs="24">
        <el-form-item label="Contact Person" prop="contact_person">
          <el-input v-model="supplier.contact_person"></el-input>
        </el-form-item>
        <!-- <el-form-item label="Contact" prop="contact">
          <el-input v-model="supplier.contact"></el-input>
        </el-form-item> -->
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item label="Telephone" prop="telephone">
          <el-input v-model="supplier.telephone"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="Address" prop="address">
      <el-input
        type="textarea"
        v-model="supplier.address"
        :autosize="{ minRows: 2, maxRows: 4 }"
      ></el-input>
    </el-form-item>
    <el-form-item label="Currency" prop="currency_id">
      <el-select v-model="supplier.currency_id">
        <el-option
          v-for="c in currencyList"
          :value="c.id"
          :key="c.id"
          :label="c.name"
        ></el-option>
      </el-select>
    </el-form-item>
    <div v-show="supplier.id" class="mb-2">
      <el-col :span="12">
        <h5 class="text-primary">Supplies</h5>
      </el-col>
      <el-col :span="12">
        <el-form
          v-show="0"
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetchSupplies(1)"
          size="small"
        >
          <el-form-item>
            <el-input
              v-model="supplies_paging.description"
              placeholder="Search supplies..."
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchSupplies(1)"
              >Search</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-table ref="supplyTable" :data="supplies.data">
        <el-table-column type="selection" width="55"> </el-table-column>
        <!-- <el-table-column type="index" :index="indexMethod" width="50"></el-table-column> -->
        <el-table-column label="Part No." prop="part_no"></el-table-column>
        <el-table-column
          label="Description"
          prop="description"
        ></el-table-column>
        <!-- <el-table-column label="Location" prop="location"></el-table-column> -->
      </el-table>
      <el-pagination
        v-if="supplies.length != 0"
        class="pt-1 pb-1"
        background
        layout="prev, pager, next"
        :total="supplies.paging.total"
        :page-size="supplies_paging.limit"
        :current-page="parseInt(supplies.paging.cur_page)"
        @current-change="fetchSupplies"
      ></el-pagination>
    </div>
    <el-button v-if="user.isRole(1)" size="small" type="primary" @click="submit"
      >Save</el-button
    >
    <el-button
      v-if="user.isRole(1)"
      v-show="supplier.id"
      size="small"
      type="info"
      @click="viewDrawer = true"
      >Add supply</el-button
    >
    <el-button
      v-if="user.isRole(1)"
      v-show="supplier.id && selectedSupplies.length != 0"
      size="mini"
      type="danger"
      @click="deleteSupplies"
      >Delete
    </el-button>
    <el-button size="small" @click="cancel">Cancel</el-button>
    <el-drawer
      size="50%"
      :visible.sync="viewDrawer"
      title="Add supplies"
      @open="handleDrawerOpen"
    >
      <div class="el-drawer__content">
        <div class="el-drawer__content-header">
          <el-input placeholder="Search..." v-model="partFilter"></el-input>
        </div>
        <div class="el-drawer__content-wrapper">
          <el-table
            ref="partsTable"
            :data="partSearchList"
            v-loading="isPartsLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              label="Part No."
              prop="part_no"
              width="150"
            ></el-table-column>
            <el-table-column
              label="Description"
              prop="description"
            ></el-table-column>
          </el-table>
        </div>
        <div class="el-drawer__footer">
          <el-button type="primary" size="small" @click="addSupplies"
            >Add selected items to supplies.</el-button
          >
        </div>
      </div>
    </el-drawer>
  </el-form>
</template>

<script>
import Supplier from "@/models/Supplier";
export default {
  name: "supplier_info",
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    currencyList() {
      return this.$store.getters["currency/glossary"];
    },
    selectedSupplies() {
      var table = this.$refs["supplyTable"];
      return table.selection;
    },
    partSearchList() {
      if (this.partFilter) {
        return this.parts.filter(item => {
          var found = false;
          found = item.part_no
            .toLowerCase()
            .includes(this.partFilter.toLowerCase());
          if (found) return true;

          found = item.description
            .toLowerCase()
            .includes(this.partFilter.toLowerCase());
          if (found) return true;

          return false;
        });
      }
      return this.parts;
    }
  },
  data() {
    return {
      isLoading: false,
      supplier: new Supplier(),
      rules: Supplier.rules(),
      supplies: [],
      supplies_paging: {
        page: 1,
        limit: 10
      },
      viewDrawer: false,
      parts: [],
      partFilter: "",
      isPartsLoading: false
    };
  },
  mounted() {
    this.$store.dispatch("currency/getList");

    if (this.$route.params && this.$route.params.id) {
      this.isLoading = true;
      Supplier.fetch(this.$route.params.id).then(resp => {
        this.supplier = new Supplier(resp);
        this.isLoading = false;
      });
      this.fetchSupplies();
      // this.$store.dispatch("part/getGlossary");
    }
  },
  methods: {
    cancel() {
      this.$router.push({ name: "suppliers" });
    },
    fetchSupplies(page) {
      this.isLoading = true;
      this.supplies_paging.page = page != undefined ? page : 1;
      Supplier.supplies(this.$route.params.id, this.supplies_paging).then(
        resp => {
          this.supplies = resp;
          this.isLoading = false;
        }
      );
    },
    submit() {
      this.$confirm(
        "Are you sure you want to save this supplier information?",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }
      )
        .then(() => {
          this.$refs["supplierForm"].validate(valid => {
            if (!valid) {
              return false;
            }
            var payload = { ...this.supplier };
            delete payload.currency;

            if (this.supplier.id) {
              this.isLoading = true;
              Supplier.put(payload).then(resp => {
                if (resp && resp.code == 200) {
                  this.$router.push({
                    name: "suppliers"
                  });
                  this.$notify({
                    type: "success",
                    message: "Supplier information saved.",
                    position: "bottom-right"
                  });
                }
                this.isLoading = false;
              });
            } else {
              this.isLoading = true;
              Supplier.create(payload).then(resp => {
                if (resp && resp.code == 200) {
                  this.$router.push({
                    name: "suppliers"
                  });
                  this.$notify({
                    type: "success",
                    message: "Supplier information saved.",
                    position: "bottom-right"
                  });
                }
                this.isWorking = false;
              });
            }
          });
        })
        .catch(() => {});
    },
    deleteSupplies() {
      this.$confirm("Are you sure you want to delete the selected supplies?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          var ids = [];
          for (let supply of this.selectedSupplies) {
            ids.push(supply.supply_id);
          }
          var payload = {
            supply_id: ids.toString(),
            supplier_id: this.supplier.id
          };
          Supplier.deleteSupplies(payload).then(resp => {
            if (resp) {
              this.fetchSupplies(1);
              this.$notify({
                type: "success",
                message: "Selected supplies deleted successfully.",
                position: "bottom-right"
              });
            }
          });
        })
        .catch(() => {});
    },
    handleDrawerOpen() {
      this.isPartsLoading = true;
      Supplier.partOptions(this.$route.params.id).then(resp => {
        this.parts = resp;
        this.isPartsLoading = false;
      });
    },
    addSupplies() {
      var table = this.$refs.partsTable;
      var ids = [];
      for (let part of table.selection) {
        ids.push(part.id);
      }
      if (ids.length == 0) {
        this.$notify({
          type: "warning",
          message: "Please select parts from the list",
          position: "bottom-right"
        });
        return;
      }

      this.isPartsLoading = true;
      Supplier.addSupplies({
        supplier_id: this.supplier.id,
        part_id: ids.toString()
      }).then(resp => {
        if (resp && resp.code == 200) {
          this.$notify({
            type: "success",
            message: "Selected parts are added successfully to supplies.",
            position: "bottom-right"
          });
          this.isPartsLoading = false;
          this.viewDrawer = false;
          this.fetchSupplies();
        }
      });
    },
    indexMethod(index) {
      return (
        this.supplies_paging.limit * (this.supplies_paging.page - 1) +
        (index + 1)
      );
    }
  }
};
</script>
